import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { LandingPage } from './pages/LandingPage';
import { WheelchairTransport } from './pages/WheelchairTransport';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceArea } from './pages/ServiceArea';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white" data-id="element-2">
        <Header data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
          <Route path="/wheelchair-transport" element={<WheelchairTransport data-id="element-8" />} data-id="element-7" />
          <Route path="/services" element={<ServicesPage data-id="element-10" />} data-id="element-9" />
          <Route path="/service-area" element={<ServiceArea data-id="element-12" />} data-id="element-11" />
          <Route path="/about" element={<AboutPage data-id="element-14" />} data-id="element-13" />
          <Route path="/contact" element={<ContactPage data-id="element-16" />} data-id="element-15" />
        </Routes>
        <Footer data-id="element-17" />
      </div>
    </Router>;
}